
      ;(function setupFavicon() {
        const hostname = window.location.hostname

        const configMap = {
          localhost: { favicon: "/mcgeraldsfavi.png" },
          "mcgeralds.com": {
            favicon: "/mcgeraldsfavi.png",
            title: "McGeralds",
          },
          "lascuoladeiquartieri.it": {
            favicon: "/lascuoladeiquartierifavi.png",
          },
          "aecfafrica.org": { favicon: "/aecffavicon.png" },
          "tasmu.gov.qa": { favicon: "/tasmufavicon.ico" },
          "alloygrowthlab.com": { favicon: "/alloydevfavi.png" },
          "coompanion.se": { favicon: "/coompanionsefavi.png" },
          "incubits.org": { favicon: "/incubitsfavi.png" },
          "app-stag.babele.co": { favicon: "/incubitsfavi.png" },
          "lms.oghub.com": { favicon: "/og_logo.png", title: "OGHUB" },
          "cyprusseeds.com": { favicon: "/cyprusseedsfavicon.png" },
          "uptakealliance.com": { favicon: "/uptakefavi.png" },
          "craftaction.eu": { favicon: "/craftfavi.png" },
          "berkeley.edu": {
            favicon: "/berkeleyfavicon.ico",
            title: "SkyHub",
            description:
              "A global hub for entrepreneurship and UC Berkeley's accelerator and incubator",
          },
          "chromeos.community": { favicon: "/chromefavicon.png" },
          "seizmic.eu": {
            favicon: "/seizmic.png",
            title: "Seizmic",
            description:
              "The seizmic APP is an open social business model innovation platform for social entrepreneurship educators and their students. Our slogan is 'Where social entrepreneurship skills grow,' and we advance the development of social entrepreneurship competencies.",
          },
          "elis.org": { favicon: "/elisfavi.png" },
          "dco.org": {
            favicon: "/dco.ico",
            title: "Digital Cooperation Organization",
          },
          "blossom.sa": {
            favicon: "./blossom.png",
            title: "DominAite"
          }
        }

        let faviconPath = "/babele.ico"
        let pageTitle = "Babele"
        let pageDescription =
          "Accelerator management software to engage stakeholders in innovation programs, online mentoring, e-learning & reporting."

        for (const key in configMap) {
          if (hostname.includes(key)) {
            const conf = configMap[key]
            faviconPath = conf.favicon ?? faviconPath
            pageTitle = conf.title ?? pageTitle
            pageDescription = conf.description ?? pageDescription
            break
          }
        }

        let link = document.querySelector("link[rel~='icon']")
        if (!link) {
          link = document.createElement("link")
          link.rel = "icon"
          document.head.appendChild(link)
        }
        link.href = faviconPath

        document.title = pageTitle

        const metaTags = [
          { name: "description", content: pageDescription },
          { name: "og:title", content: pageTitle },
          { name: "og:description", content: pageDescription },
          { name: "twitter:title", content: pageTitle },
          { name: "twitter:description", content: pageDescription },
        ]

        metaTags.forEach(({ name, content }) => {
          let meta = document.querySelector(`meta[name='${name}']`)
          if (!meta) {
            meta = document.createElement("meta")
            meta.name = name
            document.head.appendChild(meta)
          }
          meta.content = content
        })
      })()
    